import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import styles from "components/common/pagination-bar.scss";

export const PaginationBar = ({
  limit,
  onChangeLimit,
  onNextPage,
  onPreviousPage,
  pageNumber,
  totalResults
}) => (
  <div className={ styles.container }>
    <div className={ styles["page-numbers"] }>
      <button
        className={ styles["previous-button"] }
        disabled={ pageNumber === 1 }
        onClick={ onPreviousPage }
      />
      <div>Page { pageNumber } of { calculateTotalPages(limit, totalResults) }</div>
      <button
        className={ styles["next-button"] }
        disabled={ pageNumber === calculateTotalPages(limit, totalResults) }
        onClick={ onNextPage }
      />
    </div>
    <div className={ styles["limit-controls"] }>
      { renderLimitButton(limit, 20, onChangeLimit) }
      { renderLimitButton(limit, 100, onChangeLimit) }
      { renderLimitButton(limit, 250, onChangeLimit) }
    </div>
  </div>
);

PaginationBar.propTypes = {
  limit: PropTypes.number.isRequired,
  onChangeLimit: PropTypes.func.isRequired, // (number) => void
  onNextPage: PropTypes.func.isRequired, // () => void
  onPreviousPage: PropTypes.func.isRequired, // () => void
  pageNumber: PropTypes.number.isRequired,
  totalResults: PropTypes.number.isRequired
};

const renderLimitButton = (currentLimit, limit, onChangeLimit) => (
  <button disabled={ currentLimit === limit } onClick={ changeLimit(limit, onChangeLimit) }>{ limit }</button>
);

const changeLimit = (value, onChangeLimit) => () => { onChangeLimit(value); };
const calculateTotalPages = (limit, totalResults) => R.max(1, Math.ceil(totalResults / limit));



// WEBPACK FOOTER //
// ./src/js/components/common/pagination-bar.jsx